import RealizeFlashContent from './flash_content';
import RealizeFlashDismiss from './flash_dismiss';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const Realize = {
	Flash: window.Flash,
};

export default class Flash extends Realize.Flash {

  render() {
    return (
      <ReactCSSTransitionGroup
        transitionName="dismiss"
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {this.state.dismissed ? '' : this.renderFlashCustom()}
      </ReactCSSTransitionGroup>
    );
  }

  renderFlashCustom() {
    return (
      <div className={this.className()} ref="flash">
        <RealizeFlashContent {...this.props} />
        {this.props.canDismiss ? <RealizeFlashDismiss {...this.props} onClick={this.dismiss} />: ''}
      </div>
    );
  }
}
